(ns frontend.view.login.view
  (:require
   [reagent.core :as r]
   [frontend.account :as account]
   [frontend.routing :as routing]
   [frontend.view.login.mfa :as mfa]
   [frontend.view.login.mfa-setup :as mfa-setup]
   [frontend.view.login.db :as db]
   [frontend.view.login.select-account-and-role :as select-account-and-role]
   [frontend.state.current-session :as session]))

(defmethod routing/render-view :login
  [view]
  (let [data (merge @db/state
                    @(r/track account/session)
                    {:login-status @(r/track db/login-status)}
                    (:view-params view))
        custom-path (:tenant/custom-login-path @session/tenant)]
    [:div.horizontal-page


     [:div.horizontal-page__banner
      {:style {:background (str "url('"
                                (cond (= "tesi" custom-path)
                                      "/img/login/TESI-bgr-1920.jpg"
                                      :else
                                      "/img/login/zapflow-bgr-1920.png")
                                "')")}}
      [:img.horizontal-page__banner-logo
       {:src (cond (= "tesi" custom-path)
                   "/img/tesi-logo.svg"
                   :else
                   "/img/zf-logo-white.svg")}]]

     [:div.horizontal-page__body.p-4.d-block
      (cond (:mfa-data @db/state)
            [mfa/mfa-view]
            (:mfa-setup-data @db/state)
            [mfa-setup/mfa-setup-view]
            :else
            [select-account-and-role/view {:data data}])]]))
